import { urls } from 'constants/urls';
import { pathJoin } from 'utils/general';

export const rootPath = path => pathJoin(urls.root, path);
